import React, { useState } from 'react';
import { Box, Button, Input, Heading, VStack, Text, Flex, Link, InputGroup, InputRightElement, useToast } from '@chakra-ui/react';
import { FormControl, FormLabel } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { register } from '../Utilities/networks';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Register = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState('');
  const [email, setEmail]     = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleNext = (e) => {
    e.preventDefault();
    setStep(2);
  };

  const handleBack = (e) => {
    e.preventDefault();
    setStep(1);
  };

  const handleRegister = async (e) => {
    // e.preventDefault();
    // try {
    //   const response = await register({ username, email, password, phoneNumber });
    //   if (response.data.status === "success") {
    //     toast({
    //       title: "Registration Successful",
    //       description: "Your account has been created.Login to continue.",
    //       status: "success",
    //       duration: 5000,
    //       isClosable: true,
    //     });
    //     navigate('/login');
    //   } else {
    //     const errorMsg = response.data.message || "Registration failed";
    //     toast({
    //       title: "Registration Failed",
    //       description: errorMsg,
    //       status: "error",
    //       duration: 5000,
    //       isClosable: true,
    //     });
    //     setError(errorMsg);
    //   }
    // } catch (error) {
    //   console.error("Registration error", error);
    //   toast({
    //     title: "Registration Failed",
    //     description: "Registration failed. Please try again.",
    //     status: "error",
    //     duration: 5000,
    //     isClosable: true,
    //   });
    //   setError("Registration failed. Please try again.");
    // }
  };

  return (
    <Flex w="100vw" h="100vh" bg="gray.50" align="center" justify="center" p={4}>
      <Flex
        w={{ base: "90%", md: "1000px" }}
        h={{ base: "auto", md: "500px" }}
        boxShadow="2xl"
        borderRadius="lg"
        overflow="hidden"
        bg="white"
      >
        {/* Left Partition with Linear Gradient and Welcome Text */}
        <Flex
          flex="1"
          bgGradient="linear(to-r, teal.500, green.500)"
          display={{ base: "none", md: "flex" }}
          align="center"
          justify="center"
          p={6}
        >
          <Text color="white" fontSize="3xl" fontWeight="bold">
            Welcome to Care4Link
          </Text>
        </Flex>
        {/* Right Partition with Stepper Form */}
        <Box flex="1" p={8}>
          <Heading textAlign="center" mb={10} fontSize="2xl" fontWeight="semibold">
            Create an Account
          </Heading>
          <form onSubmit={step === 1 ? handleNext : handleRegister}>
            <VStack spacing={6}>
              {step === 1 ? (
                <>
                  <FormControl id="email" isRequired>
                    <FormLabel fontWeight="medium">Email</FormLabel>
                    <Input 
                      type="email" 
                      value={email} 
                      onChange={(e) => setEmail(e.target.value)}
                      variant="filled"
                      bg="gray.100" 
                      _hover={{ bg: "gray.200" }}
                    />
                  </FormControl>
                  <FormControl id="password" isRequired>
                    <FormLabel fontWeight="medium">Password</FormLabel>
                    <InputGroup>
                      <Input 
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        variant="filled" 
                        bg="gray.100" 
                        _hover={{ bg: "gray.200" }}
                      />
                      <InputRightElement width="3rem">
                        <Button h="1.5rem" size="sm" onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                  </FormControl>
                </>
              ) : (
                <>
                  <FormControl id="username" isRequired>
                    <FormLabel fontWeight="medium">Username</FormLabel>
                    <Input 
                      type="text" 
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      variant="filled" 
                      bg="gray.100" 
                      _hover={{ bg: "gray.200" }}
                    />
                  </FormControl>
                  <FormControl id="phoneNumber" isRequired>
                    <FormLabel fontWeight="medium">Phone Number</FormLabel>
                    <Input 
                      type="text" 
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      variant="filled" 
                      bg="gray.100" 
                      _hover={{ bg: "gray.200" }}
                    />
                  </FormControl>
                </>
              )}
              {error && <Text color="red.500">{error}</Text>}
              <Flex w="full" justifyContent="space-between">
                {step === 2 && (
                  <Button variant="outline" colorScheme="teal" onClick={handleBack}>
                    Back
                  </Button>
                )}
                <Button type="submit" colorScheme="teal" w={step === 2 ? "48%" : "full"} py={6} fontSize="lg">
                  {step === 1 ? "Next" : "Register"}
                </Button>
              </Flex>
              <Text mt={4} fontSize="sm">
                Already have an account?{' '}
                <Link color="teal.500" onClick={() => navigate('/login')}>
                  Login here
                </Link>
              </Text>
            </VStack>
          </form>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Register;
